import { AuditCard } from "@/features/Audit/AuditCard";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { ForeignExchangeRatesEditCard } from "./edit_card";

const client = "etl-quantilia";
const table_name = "foreign_exchange_rates";

export const ForeignExchangeRatesCard = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();

  if (!id) {
    return <div>{t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <ForeignExchangeRatesEditCard
          id={Number(id)}
          client={client}
          table_name={table_name}
        />
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
};
